import { freshBinanceQuote } from './binance';
export const scopedQuote = (instrument, raw) => {
  if(raw?.source==='binance')return freshBinanceQuote(raw)&&raw.account_adjusted?raw:null;
  if(!raw||raw.quote_available===false||!(Number(raw.bid)>0)||!(Number(raw.ask)>0))return null;
  if(raw.account_adjusted)return Number(raw.ask)>=Number(raw.bid)?raw:null;
  const midpoint=(Number(raw.bid)+Number(raw.ask))/2;
  const spread=Number(instrument?.spread??(Number(raw.ask)-Number(raw.bid)))+(instrument?.spread_type==='variable'?Number(raw.ask)-Number(raw.bid):0);
  const bid=midpoint-spread/2+Number(instrument?.shift_bid||0);
  const ask=midpoint+spread/2+Number(instrument?.shift_ask||0);
  return Number.isFinite(bid)&&Number.isFinite(ask)&&bid>0&&ask>=bid?{...raw,bid,ask}:null;
};